import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { FormBuilderComponent } from '../ui-components/';
import { ModalLibModule } from './modal-lib.module';
import { CoreLibModule } from './core-lib.module';

@NgModule({
    imports: [CommonModule, ReactiveFormsModule, CoreLibModule, ModalLibModule],
    declarations: [
       FormBuilderComponent
    ],
    exports: [
      FormBuilderComponent
    ]
})
export class FormbuilderLibModule { }
